


import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import SchemeCard from "../../../../../Components/SchemeCard/SchemeCard";
import cardImage from "../../../../../Assets/home_page_Image.png"
import SchemeCardApproval from "../../../../../Components/SchemeCard/SchemeCardApproval";
import actions from "../../../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";


const PurchaseSchemes = ({ targetRef, values, sectionNameForApproveAndReject, onClose }) => {


    const [responseData, setResponseData] = useState()

    console.log(values, "valuesssss")
    console.log(responseData, "responseDatattaatatatt")
    const TableId = useSelector((state) => state.Table.TableId);

    console.log(TableId, "TebleIddddd")

    const dispatch = useDispatch()

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId && !values) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getStakeNowSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETSTAKENOWSECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "Stake Now section retrieved successfully.") {
                    console.log("hiiii")

                    setResponseData(response?.payload?.data)
                    // setUploadedFile({
                    //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
                    //     type: "img",
                    //     progress: 100,
                    // }
                    // )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, []);

    const schemes = [
        {
            name: "Scheme Name 1",
            valueOfPurchase: "$1000",
            purchase: "13.8 Grm",
            maturity: "24 Month's",
            lockIn: "24 Month's",
            benefit: "6%*",
            closingDate: "15/Mar/2025",
            backgroundImage: cardImage, // replace with the background image URL
        },
        {
            name: "Scheme Name 2",
            valueOfPurchase: "$10000",
            purchase: "138 Grm",
            maturity: "24 Month's",
            lockIn: "24 Month's",
            benefit: "6%*",
            closingDate: "15/Mar/2025",
            backgroundImage: cardImage, // replace with the background image URL
        },
    ];

    return (
        <>
            <Box sx={{ p: 4, background: 'white' }} id="name" ref={targetRef}>
                <Box sx={{ textAlign: "center", mb: 4 }}>
                    <Typography
                        variant="h3"
                        gutterBottom
                        sx={{ paddingBottom: "5px" }}
                    >
                        {values?.title || responseData?.heading} &
                        {' '}<span style={{ color: "black", fontWeight: "800" }}>{values?.subtitle || responseData?.sub_heading}</span>
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            paddingBottom: "5px",
                            maxWidth: "900px",
                            margin: "0 auto",
                            textAlign: "center",
                            color: "#b0aaaa",

                        }}
                    >
                        {values?.content || responseData?.content}
                    </Typography>
                </Box>


                <Box
                // sx={{
                //       position: "relative",
                //       display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    {/* <Grid
                      container justifyContent="center" spacing={6} alignItems="center"
                     > */}
                    {/* {schemes.map((schemes, index) => ( */}
                    {/* <SchemeCardApproval schemes={schemes}/> */}
                    {/* ))} */}
                    {/* </Grid> */}
                </Box>



            </Box>
            <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject} />

        </>
    );
};

export default PurchaseSchemes;
